import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { HttpStatusCode } from "axios";
import dayjs from "dayjs";
import {
  notifyApiCallFailed,
  showNotification,
} from "../notifications/notificationsSlice";
import { logoutUser } from "../user/userThunks";

export const searchApplications = createAsyncThunk(
  "applicationsSearch/search",
  async ({ search_type, search_criteria, date_range }, api) => {
    const baseUrl =
      process.env.REACT_APP_USE_LOCAL_API_URL === "true"
        ? process.env.REACT_APP_LOCAL_API_URL
        : process.env.REACT_APP_EXTERNAL_API_URL;
    try {
      let config = {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      };
      const response = await axios.post(
        baseUrl + "/private_aviation_forms/list",
        {
          search_type: search_type,
          search_criteria: search_criteria,
          start_day: dayjs(date_range[0]).format("YYYY-MM-DD"),
          end_day: dayjs(date_range[1]).format("YYYY-MM-DD"),
        },
        config
      );

      return response;
    } catch (error) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        // User is not authorized
        api.dispatch(logoutUser());
        return api.rejectWithValue(null);
      } else {
        api.dispatch(notifyApiCallFailed());
        return api.rejectWithValue(null);
      }
    }
  }
);

export const fetchAviationForm = createAsyncThunk(
  "applicationsSearch/fetchAviationForm",
  async ({ id }, api) => {
    const baseUrl =
      process.env.REACT_APP_USE_LOCAL_API_URL === "true"
        ? process.env.REACT_APP_LOCAL_API_URL
        : process.env.REACT_APP_EXTERNAL_API_URL;
    try {
      let config = {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      };
      const response = await axios.get(
        `${baseUrl}/private_aviation/forms/${id}`,
        config
      );
      if (response.status === HttpStatusCode.Ok) {
        return response.data;
      }
      throw new Error();
    } catch (error) {
      api.dispatch(notifyApiCallFailed());
      return api.rejectWithValue(null);
    }
  }
);

export const fetchAviationFormStep = createAsyncThunk(
  "applicationsSearch/fetchAviationFormStep",
  async ({ id, step }, api) => {
    const baseUrl =
      process.env.REACT_APP_USE_LOCAL_API_URL === "true"
        ? process.env.REACT_APP_LOCAL_API_URL
        : process.env.REACT_APP_EXTERNAL_API_URL;
    try {
      let config = {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      };
      const response = await axios.get(
        `${baseUrl}/private_aviation/forms/${id}/fetch_step/${step}`,
        config
      );

      if (response.status === HttpStatusCode.Ok) {
        return response.data;
      }
      throw new Error();
    } catch (error) {
      api.dispatch(notifyApiCallFailed());
      return api.rejectWithValue(null);
    }
  }
);

export const updateAviationFormStep = createAsyncThunk(
  "applicationsSearch/updateAviationFormStep",
  async ({ id, step, data }, api) => {
    const baseUrl =
      process.env.REACT_APP_USE_LOCAL_API_URL === "true"
        ? process.env.REACT_APP_LOCAL_API_URL
        : process.env.REACT_APP_EXTERNAL_API_URL;
    try {
      let config = {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      };
      const response = await axios.patch(
        `${baseUrl}/private_aviation/forms/${id}/update_step/${step}`,
        { content: data },
        config
      );

      if (response.status === HttpStatusCode.Ok) {
        return response.data;
      }
      throw new Error();
    } catch (e) {
      if (
        axios.isAxiosError(e) &&
        e.response.status === HttpStatusCode.UnprocessableEntity &&
        e.response.data.errors
      ) {
        api.dispatch(
          showNotification({
            type: "error",
            message: "Error",
            description: (
              <div
                dangerouslySetInnerHTML={{
                  __html: e.response.data.errors.replace(
                    /(?:\r\n|\r|\n)/g,
                    "<br />"
                  ),
                }}
              />
            ),
          })
        );
      } else {
        api.dispatch(notifyApiCallFailed());
      }
      return api.rejectWithValue(null);
    }
  }
);

export const updateCustomerCode = createAsyncThunk(
  "applicationsSearch/updateCustomerCode",
  async ({ id, customerCode }, api) => {
    const baseUrl =
      process.env.REACT_APP_USE_LOCAL_API_URL === "true"
        ? process.env.REACT_APP_LOCAL_API_URL
        : process.env.REACT_APP_EXTERNAL_API_URL;
    try {
      let config = {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      };
      const response = await axios.patch(
        `${baseUrl}/private_aviation/forms/${id}/update_customer_code/`,
        { content: { customer_code: customerCode } },
        config
      );
      if (response.status === HttpStatusCode.Ok) {
        return response.data;
      }
      throw new Error();
    } catch (error) {
      api.dispatch(notifyApiCallFailed());
      return api.rejectWithValue(null);
    }
  }
);
